import { useEffect, useState } from 'react';

export interface SubProjectNavigationItem {
  id: number;
  name: string;
}

export const matchesSubProjectSearch = (query: string, project: SubProjectNavigationItem): boolean => {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return true;

  return project.name.toLowerCase().includes(normalizedQuery) || project.id.toString().includes(normalizedQuery);
};

export const filterSubProjects = (query: string, projects: SubProjectNavigationItem[]): SubProjectNavigationItem[] =>
  projects.filter((project) => matchesSubProjectSearch(query, project));

export const useSubProjectSearch = (selectedSubProjects: SubProjectNavigationItem[], projectBasePath: string) => {
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    setSearchQuery('');
  }, [projectBasePath]);

  const filteredSubProjects = filterSubProjects(searchQuery, selectedSubProjects);

  const clearSearch = () => {
    setSearchQuery('');
  };

  return {
    clearSearch,
    filteredSubProjects,
    searchQuery,
    setSearchQuery,
  };
};
